module.exports = __webpack_public_path__ + "static/img/shl_small_basketball_certificate_back_image.886b2b1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_basketball_certificate_back_image.jpg
// module id = TXB9
// module chunks = 5